// extracted by mini-css-extract-plugin
export default {"block":"ServicesPage_block__o1OUd","block__title":"ServicesPage_block__title__7dwdm","block__cards":"ServicesPage_block__cards__VdPKf"};